import Button from '@mui/material/Button';
import styled from '@emotion/styled';

export const StyledNavButton = styled(Button)`
  color: #c3b9b5;
  font-size: 1.25rem;
  line-height: 1.25rem;
  font-family: 'Futura New Bold', serif;
  &:hover {
    color: #59443f;
    background-color: inherit;
  }
  @media (max-width: 96.875rem) {
    font-size: 90%;
  }
`;
